import { queryOptions } from '@tanstack/react-query'

import { fetchExerciseGoal } from '../dal/exercise-goal-dal'
import { fetchExerciseWeek } from '../dal/exercise-week-dal'
import { queryKeys } from './query-keys'

const EXERCISE_QUERY_STALE_TIME_MS = 5 * 60 * 1000

export const exerciseGoalQueryOptions = (yearWeek?: string) =>
  queryOptions({
    queryKey:
      yearWeek == null
        ? queryKeys.exercise.goalCurrent()
        : queryKeys.exercise.goal(yearWeek),
    queryFn: () => fetchExerciseGoal(yearWeek),
    staleTime: EXERCISE_QUERY_STALE_TIME_MS,
  })

export const exerciseWeekQueryOptions = (yearWeek: string) =>
  queryOptions({
    queryKey: queryKeys.exercise.week(yearWeek),
    queryFn: () => fetchExerciseWeek(yearWeek),
    staleTime: EXERCISE_QUERY_STALE_TIME_MS,
  })
